import React from 'react';
import styled from 'styled-components';
import { usePlayer } from '../contexts/PlayerContext';

const MiniContainer = styled.div<{ show: boolean }>`
  position: fixed;
  top: 20px;
  right: 20px;
  width: 300px;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 999;
  display: ${props => props.show ? 'block' : 'none'};
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const MiniHeader = styled.div`
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 12px;
`;

const MiniTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--primary-color);
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 16px;
  
  &:hover {
    color: white;
  }
`;

const MiniSongInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

const MiniCover = styled.div`
  width: 48px;
  height: 48px;
  background: var(--primary-color);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`;

const MiniDetails = styled.div`
  flex: 1;
  min-width: 0;
`;

const MiniSongName = styled.div`
  font-weight: 500;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const MiniArtist = styled.div`
  color: var(--text-muted);
  font-size: 0.8rem;
`;

const MiniControls = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`;

const MiniButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  padding: 4px;
  
  &:hover {
    color: var(--primary-color);
  }
`;

const MiniPlayButton = styled(MiniButton)`
  background: var(--primary-color);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  
  &:hover {
    background: var(--secondary-color);
    color: white;
  }
`;

interface MiniPlayerProps {
  show: boolean;
  onClose: () => void;
}

const MiniPlayer: React.FC<MiniPlayerProps> = ({ show, onClose }) => {
  const { currentSong, isPlaying, pauseSong, resumeSong, nextSong, previousSong } = usePlayer();

  if (!currentSong) return null;

  return (
    <MiniContainer show={show}>
      <MiniHeader>
        <MiniTitle>🎵 Tocando Agora</MiniTitle>
        <CloseButton onClick={onClose}>✕</CloseButton>
      </MiniHeader>
      
      <MiniSongInfo>
        <MiniCover>🎵</MiniCover>
        <MiniDetails>
          <MiniSongName>{currentSong.name}</MiniSongName>
          <MiniArtist>Soulful Roots</MiniArtist>
        </MiniDetails>
      </MiniSongInfo>
      
      <MiniControls>
        <MiniButton onClick={previousSong}>⏮️</MiniButton>
        <MiniPlayButton onClick={isPlaying ? pauseSong : resumeSong}>
          {isPlaying ? '⏸️' : '▶️'}
        </MiniPlayButton>
        <MiniButton onClick={nextSong}>⏭️</MiniButton>
      </MiniControls>
    </MiniContainer>
  );
};

export default MiniPlayer;